import { AppState } from 'Features/App/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedBooleanStatusType, SelectedDataReceivedStatusType, SelectedStormModeStatusType } from './utils';

/**
 * Выбранные айди для фильтров общих станций/источников (в отчетах при редактировании не нужны)
 * ! ВАЖНО: `undefined` значит, что фильтры НЕ выбраны
 */

export const FILTERS_SLICE = 'filters';
export type FiltersSliceState = {
  stationSearchText: string,
  /** выбранные регионы (может быть либо 1 ugms либо ugms и cgms) */
  selectedRegion: {
    /** выбранный айди региона (ugms или cgms для select) */
    id: number | undefined,
    /** список регионов, по которым нужно искать (может быть либо 1 ugms либо ugms и cgms) */
    ids?: number[],
  },
  selectedType: {
    id: number | undefined
  },
  // selectedStationType
  selectedDatasourceTypesIds: number[] | undefined,

  // статусы
  selectedEnableMode: SelectedBooleanStatusType,
  selectedDangerMode: SelectedBooleanStatusType,
  selectedSoftRelease: SelectedBooleanStatusType,
  selectedDataReceived: SelectedDataReceivedStatusType,
  selectedStormMode: SelectedStormModeStatusType,
}
const initialState: FiltersSliceState = {
  stationSearchText: '',
  selectedRegion: {
    id: undefined,
  },
  selectedType: {
    id: undefined
  },
  selectedDatasourceTypesIds: undefined,
  selectedEnableMode: undefined,
  selectedDangerMode: undefined,
  selectedSoftRelease: undefined,
  selectedDataReceived: undefined,
  selectedStormMode: undefined,
};

const filtersSlice = createSlice({
  name: FILTERS_SLICE,
  initialState,
  reducers: {
    setStationSearchText: (state, { payload }: PayloadAction<string>) => {
      state.stationSearchText = payload;
    },
    setSelectedRegion: (state, { payload }: PayloadAction<FiltersSliceState['selectedRegion']>) => {
      state.selectedRegion = payload;
    },
    setSelectedTypeId: (state, { payload }: PayloadAction<FiltersSliceState['selectedType']>) => {
      state.selectedType = payload;
    },
    setSelectedDatasourceTypesIds: (state, { payload }: PayloadAction<FiltersSliceState['selectedDatasourceTypesIds']>) => {
      if (payload?.length) state.selectedDatasourceTypesIds = payload;
      else state.selectedDatasourceTypesIds = initialState.selectedDatasourceTypesIds;
    },

    setSelectedEnableMode: (state, { payload }: PayloadAction<FiltersSliceState['selectedEnableMode']>) => {
      state.selectedEnableMode = payload;
    },
    setSelectedDangerMode: (state, { payload }: PayloadAction<FiltersSliceState['selectedDangerMode']>) => {
      state.selectedDangerMode = payload;
    },
    setSelectedSoftRelease: (state, { payload }: PayloadAction<FiltersSliceState['selectedSoftRelease']>) => {
      state.selectedSoftRelease = payload;
    },
    setSelectedDataReceived: (state, { payload }: PayloadAction<FiltersSliceState['selectedDataReceived']>) => {
      state.selectedDataReceived = payload;
    },
    setSelectedStormMode: (state, { payload }: PayloadAction<FiltersSliceState['selectedStormMode']>) => {
      state.selectedStormMode = payload;
    },
    resetFiltersSlice: () => initialState,
  },
});

export const {
  setStationSearchText,
  setSelectedRegion,
  setSelectedTypeId,
  setSelectedDatasourceTypesIds,

  setSelectedEnableMode,
  setSelectedDangerMode,
  setSelectedSoftRelease,
  setSelectedDataReceived,
  setSelectedStormMode,
  resetFiltersSlice,
} = filtersSlice.actions;
export default filtersSlice.reducer;

// % _______________ SELECTORS _____________

export const noFiltersSelector = (state:AppState) => JSON.stringify(state[FILTERS_SLICE]) === JSON.stringify(initialState);

export const stationSearchTextSelector = (state:AppState) => state[FILTERS_SLICE].stationSearchText;

export const selectedRegionIdSelector = (state:AppState) => state[FILTERS_SLICE].selectedRegion.id;
export const selectedTypeIdSelector = (state:AppState) => {return  state[FILTERS_SLICE].selectedType.id};
export const selectedRegionIdsSelector = (state:AppState) => state[FILTERS_SLICE].selectedRegion.ids;

export const selectedDatasourceTypesIdsSelector = (state:AppState) => state[FILTERS_SLICE].selectedDatasourceTypesIds;

export const selectedEnableModeSelector = (state:AppState) => state[FILTERS_SLICE].selectedEnableMode;
export const selectedDangerModeSelector = (state:AppState) => state[FILTERS_SLICE].selectedDangerMode;
export const selectedSoftReleaseSelector = (state:AppState) => state[FILTERS_SLICE].selectedSoftRelease;
export const selectedDataReceivedSelector = (state:AppState) => state[FILTERS_SLICE].selectedDataReceived;
export const selectedStormModeSelector = (state:AppState) => state[FILTERS_SLICE].selectedStormMode;
